var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'micro-front-end-container': true,
    'mfe-error': _vm.error,
  }},[(!_vm.error)?_vm._t("default"):_c('div',[_c('FourOhFour')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }